import React from "react";
import { Modal, Button } from "react-bootstrap";
import PropTypes from "prop-types";
import {useTranslation} from "react-i18next";
import {CButton} from "@coreui/react";
import "./LogoutModal.css";

const LogoutModal = ({ show, handleConfirm, handleClose, title, message, tag }) => {
    const { t } = useTranslation();
    return (
        <Modal
            show={show}
            onHide={handleClose}
            style={{ backgroundColor: 'your-background-color' }} // Change 'your-background-color' to your desired color
            centered  // Center the modal vertically
        >
            <Modal.Header closeButton className="text-center align-items-center">
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ borderBottom: 'none' }} className="d-flex justify-content-center">
                {message}
            </Modal.Body>
            {
                tag !== "Login" && (
                    <Modal.Footer style={{ justifyContent: 'center', borderTop: 'none' }}>
                        <CButton
                            className="cancel-button"
                            onClick={handleClose}
                        >
                            {t('cancel')}
                        </CButton>
                        <CButton
                            className="confirm-button"
                            onClick={handleConfirm}
                        >
                            {t('confirm')}
                        </CButton>
                    </Modal.Footer>
                )
            }
            {
                tag === "Login" && (
                    <Modal.Footer style={{ justifyContent: 'center', borderTop: 'none' }}>
                        <Button  className="confirm-button" onClick={handleConfirm} size="lg">
                            {t('OK')}
                        </Button>
                    </Modal.Footer>
                )
            }
        </Modal>
    );
};

LogoutModal.propTypes = {
    show: PropTypes.bool.isRequired,
    handleConfirm: PropTypes.func.isRequired,
    handleClose: PropTypes.func,
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    tag: PropTypes.string.isRequired
};

export default LogoutModal;
